<template>
  <div class="head">
    <p class="last-modified">最后更新于2022年4月</p>
    <a class="download-pdf" href="../../../static/resume.pdf">下载 PDF</a>
  </div>
</template>

<script>
export default {
  name: "Head",
  data() {
    return {};
  },
  mounted() {},
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/components/common/head.vue